import { useClassNames } from '@magnetic/hooks';
import React, { forwardRef } from 'react';
import { TagFrame } from '../frame/index.js';
import './style.css.js';

const colorMap = [void 0, "a", "b", "d", "e", "f", "g", "i", "k", "c", "h"];
const ColoredTag = forwardRef(
  ({ children, className, color = 1, ...props }, ref) => {
    const classNames = useClassNames(
      "mds-rebuild-tag-colored",
      { [`mds-rebuild-tag-color-${colorMap[color]}`]: Boolean(color) },
      className
    );
    return /* @__PURE__ */ React.createElement(TagFrame, {
      ...props,
      className: classNames,
      ref
    }, children);
  }
);
ColoredTag.displayName = "Tag.Colored";

export { ColoredTag };
//# sourceMappingURL=index.js.map
